<template lang="pug">

	p.lesson-block__title.main-block__title {{content.header}}


</template>

<script>
export default {
  props: {
    content: {}
  }
};
</script>
